(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["bg"] = {
            name: "bg",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": " ",
                ".": ",",
                groupSize: [3],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": " ",
                    ".": ",",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "",
                    abbr: "",
                    pattern: ["-n $","n $"],
                    decimals: 2,
                    ",": " ",
                    ".": ",",
                    groupSize: [3],
                    symbol: "лв."
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["неделя","понеделник","вторник","сряда","четвъртък","петък","събота"],
                        namesAbbr: ["нед","пон","вт","ср","четв","пет","съб"],
                        namesShort: ["нд","пн","вт","ср","чт","пт","сб"]
                    },
                    months: {
                        names: ["януари","февруари","март","април","май","юни","юли","август","септември","октомври","ноември","декември"],
                        namesAbbr: ["яну","фев","мар","апр","май","юни","юли","авг","сеп","окт","ное","дек"]
                    },
                    AM: [""],
                    PM: [""],
                    patterns: {
                        d: "d.M.yyyy 'г.'",
                        D: "dd MMMM yyyy 'г.'",
                        F: "dd MMMM yyyy 'г.' H:mm:ss",
                        g: "d.M.yyyy 'г.' H:mm",
                        G: "d.M.yyyy 'г.' H:mm:ss",
                        m: "d MMMM",
                        M: "d MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "H:mm",
                        T: "H:mm:ss",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM yyyy 'г.'",
                        Y: "MMMM yyyy 'г.'"
                    },
                    "/": ".",
                    ":": ":",
                    firstDay: 1
                }
            }
        };
    })();

}));
